import React, { useEffect, useCallback, useState} from 'react';
import PlaneConfig from './PlaneConfig.js';
import PlanePlay from './PlanePlay.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import AccumulatorMapper from "components/effects/AccumulatorMapper.js";
import Plane from './Plane.js';
import ParametersMapper from '../ParametersMapper.js';
import {connect} from 'react-redux';
import {setPlaneMapping} from 'actions/index.js';
import CheckboxParameter from '../CheckboxParameter.js';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js"

const PlaneParametersComponent = ({isDraggable, sequencerEngine, effect, planeMapping, setPlaneMapping}) => { 
    let [debug, setDebug] = useState(12);
    let [hideUI, setHideUI] = useState(effect.hideUI);
    let className = "control-parameters plane-parameters";
    if (hideUI) {
        className += " hide-ui";
    }

    useEffect(() => {
        effect.hideUI = hideUI;
    }, [hideUI]);

    return (
        <div className={className}>
          <div className="acc-column">
            <Plane debug={debug} hideUI={hideUI} isDraggable={isDraggable} sequencerEngine={sequencerEngine} effect={effect}>
            <div className="control-toolbar">
              <div className="row-powa">
                <div
                  onClick={(e) => {
                      e.stopPropagation();
                      setPlaneMapping(planeMapping ? undefined : effect);
                  }}
                  className={planeMapping ? "mappy-btn mapping" : "mappy-btn"}>
                  map devices
                </div>
                <AccumulatorMapper
                  onMapped={() => []}
                  effect={effect}
                  skipSelected={true}
                  label="map params"
                />
              <PlanePlay effect={effect}/>
              </div>
              <PlaneConfig setHideUI={setHideUI} hideUI={hideUI} sequencerEngine={sequencerEngine} effect={effect}/>
           </div>
           </Plane>
           </div>
       </div>
    );
};

const ListItem = ({effect, item, i, key, isCurrent}) => {
    let [value, setValue] = useState(item === undefined ? "" : undefined);

    useEffect(() => {
        if (item === undefined) {
            setValue("");
        } else {
            setValue(undefined);
        }
    }, [item, setValue]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            let _value = parseFloat(value);
            if (isNaN(_value)) {
                return;
            }
            let _list = effect.valueList;
            if (i === undefined) {
                // add the item
                effect.valueList = [... _list, _value];
            }  else {
                // set the item
                _list[i] = _value;
                effect.valueList = _list;
            }
            setValue(undefined);
        }
    }, [setValue, value, effect, i]);

    const onDelete = useCallback((e) => {
        e.stopPropagation();
        let valueList = [... effect.valueList];
        valueList.splice(i, i);
        effect.valueList = valueList;
    }, [effect, i]);

    if (value !== undefined) {
        return (
            <div className="value-list-item">
              <input
                placeholder="Enter value"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={onKeyDown}
              />
            </div>
        );
    } else {
        return (
            <div
              onClick={() => setValue(item)}
              className={isCurrent ? "value-list-item current" : "value-list-item"}>
              <div>{item}</div>
              <div onClick={onDelete} className="delete-btn">x</div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        planeMapping: state.effects.planeMapping
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPlaneMapping: p => dispatch(setPlaneMapping(p))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaneParametersComponent);
